import _ from 'lodash';

import Assignee from './assignee';
import createEnum from 'scripts/lib/create_enum';
import createModel, { prop } from './lib/create_model';
import InteractionType from 'models/interaction_type';

const AgentParticipantStatus = createEnum('ACTIVE', 'OFFERED', 'YIELDED');
const RoutingStatus = createEnum('ACTIVE', 'OFFERED', 'QUEUED', 'REQUEUED', 'OFFERED_ACTIVE', 'OFFERED_REQUEUED');

const AgentParticipant = createModel({
  modelName: 'AgentParticipant',

  properties: {
    id: prop(String).isRequired,
    status: prop().oneOf(..._.keys(AgentParticipantStatus)),
    updatedAt: prop(String),
  },

  updateStatus(newStatus) {
    this.status = newStatus;
    this.updatedAt = new Date().toISOString();
  },

  statics: {
    create(attrs) {
      return new this(_.assign({}, attrs));
    },
  },
});

const MailSessionTypes = Object.freeze([
  InteractionType.ABANDONED_CALL,
  InteractionType.EMAIL,
  InteractionType.VOICEMAIL,
]);

const MessagingSessionTypes = Object.freeze([
  InteractionType.CHAT,
  InteractionType.FB_MESSENGER,
  InteractionType.SMS,
  InteractionType.TWITTER,
  InteractionType.WHATSAPP,
]);

const RoutingSession = createModel({
  modelName: 'RoutingSession',

  properties: {
    id: prop(String).isRequired,
    type: prop().oneOf(..._.keys(InteractionType)).isRequired,
    customerIdentifier: String,
    endpointAddress: String,
  },
});

const RoutingQueueItem = createModel({
  modelName: 'RoutingQueueItem',

  properties: {
    id: prop(String).isRequired,
    agents: [AgentParticipant],
    assignee: prop(Assignee),
    conversationId: String,
    customerId: String,
    status: prop().oneOf(..._.keys(RoutingStatus)),
    sessions: [RoutingSession],
    _version: Number,
  },

  getLatestSession() {
    return _.last(this.sessions);
  },

  updateStatus(newStatus) {
    this.status = newStatus;
  },

  updateParticipantStatus(agentId, newStatus) {
    _.find(this.agents, { id: agentId }).updateStatus(newStatus);
  },

  getOfferingAgentId() {
    let offeringAgent = _.find(this.agents, agent => agent.status === AgentParticipantStatus.OFFERED);
    return offeringAgent && offeringAgent.id;
  },

  getAgentParticipantStatus(agentId) {
    let agentParticipant = _.find(this.agents, { id: agentId });
    return agentParticipant && agentParticipant.status;
  },

  getAssignedAgentId() {
    return _.get(this.assignee, 'agentId');
  },

  getSessionByType(sessionType) {
    return _.find(this.sessions, ['type', sessionType]);
  },

  getYieldedAgentId() {
    let yieldedAgent = _.find(this.agents, agent => agent.status === AgentParticipantStatus.YIELDED);
    return yieldedAgent && yieldedAgent.id;
  },

  statics: {
    create(attrs) {
      return new this(_.assign({}, attrs));
    },
  },
});

export {
  AgentParticipant,
  AgentParticipantStatus,
  MailSessionTypes,
  MessagingSessionTypes,
  RoutingSession,
  RoutingStatus,
};

export default RoutingQueueItem;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/routing_queue_item.js